// src/context/AuthProvider.js

import React, { createContext, useState, useEffect } from 'react';
import api from '../api/api';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Cette fonction s'exécute 1 SEULE FOIS au démarrage
        const token = localStorage.getItem('token');

        if (token) {
            try {
                const decoded = jwtDecode(token);
                if (decoded.exp * 1000 > Date.now()) {
                    // Le token est valide
                    const userData = JSON.parse(decoded.sub); 
                    setUser(userData);
                    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

                } else {
                    // Le token est expiré
                    logout(); // <-- MODIFIÉ : On appelle logout() pour tout nettoyer
                }
            } catch (e) {
                console.error("Erreur en décodant le token au démarrage:", e);
                logout(); // <-- MODIFIÉ : On appelle logout() pour tout nettoyer
            }
        }
        // On a fini de vérifier, on peut afficher l'application
        setLoading(false);
    }, []);

    // <-- MODIFIÉ : La signature de login() change -->
    const login = (token) => {
        try {
            const decoded = jwtDecode(token);
            
            // Stockage localStorage
            localStorage.setItem('token', token);

            const userData = JSON.parse(decoded.sub);
            
            // Mise à jour du State
            setUser(userData);
            
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            
            console.log("AuthProvider: Utilisateur connecté avec succès !", userData);
        } catch (e) {
            console.error("AuthProvider: Le token reçu est invalide ou le 'sub' n'est pas du JSON", e);
            logout();
        }
    };

    const logout = () => {
        // Nettoyage complet
        localStorage.removeItem('token');
        
        setUser(null);

        delete api.defaults.headers.common['Authorization'];
    };
    
    const refreshToken = (token) => {
        try {
            const decoded = jwtDecode(token);
            const userData = JSON.parse(decoded.sub);

            // On met à jour QUE le token et le user (au cas où les claims ont changé)
            localStorage.setItem('token', token);
            setUser(userData); // Rafraîchit les infos utilisateur si elles ont changé dans le token
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            
            console.log("AuthProvider: Token rafraîchi avec succès !");

        } catch (e) {
            console.error("AuthProvider: Le nouveau token de rafraîchissement est invalide", e);
            logout(); // Si le refresh token est mauvais, on déconnecte
        }
    };

    // Si on vérifie encore le token, on affiche un écran de chargement
    if (loading) {
        return <div>Chargement de l'application...</div>;
    }

    // Une fois la vérification terminée, on affiche l'application
    return (
        <AuthContext.Provider value={{ 
            user, 
            login, 
            logout, 
            refreshToken, 
            isAuthenticated: !!user 
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;